export const COLORS = {
  white: 'rgba(255,255,255,1)',
  black: 'rgba(0,0,0,1)',
  'BG-dark': 'rgba(6, 5, 24, 1)',
  'BG-light': 'rgba(230, 230, 241, 1)',
  'BG-light-overlay-darker-1': 'rgba(211, 211, 227, 1)',
  'BG-light-overlay-lighter-1': 'rgba(252, 252, 255, 1)',
  'text-light-100': 'rgba(255, 255, 255, 1)',
  'text-light-85': 'rgba(230, 230, 241, 1)',
  'text-light-50': 'rgba(230, 230, 241, 0.5)',
  'text-light-30': 'rgba(230, 230, 241, 0.3)',
  'text-dark-50': 'rgba(6, 5, 24, 0.5)',
  'accent-yellow': 'rgba(222, 235, 43, 1)',
  'accent-primary': 'rgba(204, 32, 207, 1)',
  'accent-blue': 'rgba(30, 24, 180, 1)',
  'element-opacity-8': 'rgba(217, 217, 217, 0.08)',
  'element-dark-opacity-12': 'rgba(6, 5, 24, 0.12)',
  'element-dark-opacity-8': 'rgba(6, 5, 24, 0.06)',
  'book-intro-details-background': 'rgba(23, 22, 39, 1)',
} as const;
